var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertaSucesso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 45,
    height: 45,
    x: 2.5,
    y: 2.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse-4",
    cx: 25,
    cy: 25,
    rx: 25,
    ry: 25
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 0,
    y: 0,
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#ellipse-4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(54,216,150)",
    fillRule: "evenodd",
    d: "M40 17.5l-3.525-3.55L20 30.425l-6.475-6.45L10 27.5l10 10 20-20z"
  }))), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0,
    stroke: "rgb(54,216,150)",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 12,
    mask: "url(#mask-5)",
    xlinkHref: "#ellipse-4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertaSucesso);
export default __webpack_public_path__ + "static/media/alerta_sucesso.bef68332cd597e1b195e04160b276563.svg";
export { ForwardRef as ReactComponent };